module.exports = __webpack_public_path__ + "img/nav.d779b134.svg";